import React, {FC, useState, useRef, ChangeEvent , useEffect  } from 'react'
import { Controller, useForm } from 'react-hook-form'
import Avatar from 'react-avatar'
import lRut from 'rut.js'

import './style.scss'
import CONFIG from '../../../config'
import { utils } from '../../utils'
import { IAuthRegisterForm, IAuthRegisterPassportForm, EDocumentType, INationality, IForecast, IGender, IRegion, ICity, ICommune, FormResponseStatus } from '../../models'
import { authService, formData, userService, auditService } from '../../services'
import { Text, Input, Radio, Button, Checkbox, Select, Icon, FormFieldset, FormLabel, FormLabelError, FormTitle, FormMessageInfo, DatePicker, DatePickerInput, FormFieldLoading } from '../../components/UI'
import { Modal, useModal } from '../../components/UI/Modal'
import {
    useForecasts,
    useUserGenders,
    useUserNationalities,
    useRegions,
    useCities,
    useCommunes,
    useSolem
} from '../../hooks'
import avatarDefaultImg from '../../assets/img/avatar-default.jpg'
import { isObjectEmpty } from '../../utils/utils'
import {TermAndCondition} from "../UI/TermAndCondition";
import { ShowPassword } from '../UI/Input/ShowPassword'

type RegisterFormProps = {
    docType: EDocumentType,
    passportFiles?: IAuthRegisterPassportForm,
    onSubmitChange(status: FormResponseStatus, message?: string): void
}

const getDocumentNumber = (docType: number) => {
    let lsFormData: any = formData.get()
    return (lsFormData && docType === Number(lsFormData.documentTypeId)  ? lsFormData.documentNumber : '')
}

const getEmail = () => {
    let lsFormData: any = formData.get()
    //console.log("**** lsFormData:",lsFormData)
    //console.log("**** result:", lsFormData.email ? lsFormData.email : '')
    if (lsFormData){
        return (lsFormData.email ? lsFormData.email : '')
    }
    return ''
}

const getPhone = () => {
    let lsFormData: any = formData.get()
    return (lsFormData && lsFormData.cellphone ? lsFormData.cellphone : '')
}

const RegisterForm:FC<RegisterFormProps> = ({ docType = EDocumentType.rut, passportFiles, onSubmitChange  })  => {



    const docNumber = getDocumentNumber(docType)
    const stEmail = getEmail()
    const stPhone = getPhone();

    const defaultValues = {
        file: '',
        documentTypeId: '',
        documentNumber: docNumber,
        firstName: '',
        lastName: '',
        secondName: '',
        dateBirth: '',
        nationalityId: '',
        forecastId: '',
        genderId: '',
        email: stEmail,
        regionId: '',
        cityId: '',
        communeId: '',
        address: '',
        phone: stPhone,
        password: '',
        confirmPassword: '',
        term: false
    }
    const { register, handleSubmit, formState: { errors }, watch, setValue, getValues, clearErrors, setError, reset, setFocus, control } = useForm<IAuthRegisterForm>({
        defaultValues
    })
    const [avatarImg, setAvatarImg] = useState<string>('')
    const [submited, setSubmited] = useState<boolean>(false)
    const modal = useModal()
    const modalTermAndCond = useModal()
    const password = useRef({})
    password.current = watch('password', '')
    const [showPassword, setShowPassword] = useState<boolean>(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false)

    const nationalities = useUserNationalities()
    const forecasts = useForecasts()
    const genders = useUserGenders()
    const regions = useRegions()
    const cities = useCities()
    const communes = useCommunes()
    const { getSolemNamesByRut } = useSolem()

    useEffect(() => {
        const getSolemNames = async () => {
            const  resp: any = await getSolemNamesByRut(docNumber)
            //console.log('resp',resp)
            if (!isObjectEmpty(resp)){
                const apellido1 = resp.lastname.split(' ')[0]
                const apellido2 = resp.lastname.replace(apellido1,'')
                console.log(apellido1, apellido2)
                setValue('firstName', resp.names)
                setValue('lastName', apellido1)
                setValue('secondName', apellido2)
            }
        }
        if (docType === 1) getSolemNames().catch(console.error)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const fieldErrorRemove = (field: any, value: string) => {
        setValue(field, value, {
            shouldValidate: true,
            shouldDirty: true
        })
    }

    const postForm = async (data: any) => {
        const resp: any = await authService.register(data)
        //console.log("**** data:",data)
        const document_type_id = Number( data.get('document_type_id'))
        const document_number = data.get('document_number')
        //console.log("**** document_type_id:",document_type_id)
        //console.log("**** document_number:",document_number)
        //console.log("**** resp:",resp)
        if(resp && resp.status === 'Ok') {
            await auditService.updatePatienteRegister({
                status: "up_register_final",
                document_type_id : document_type_id,
                document_number : document_number
            })
            formData.remove()
            reset(defaultValues)
            setSubmited(false)
            setTimeout(() => onSubmitChange('SUCCESS'), 800)

        } else {
            await auditService.updatePatienteRegister({
                status: "err_register_final",
                document_type_id : document_type_id,
                document_number : document_number
            })
            setSubmited(false)
            //console.log("**** final:",document_number)
            console.log("**** errors:",resp)
            setTimeout(() => onSubmitChange('ERROR', resp?.error?.errors[0]?.msg), 800)
        }
    }

    const onAvatarChange = (event: any) => {
        const { target: { files } } = event

        if(files && files[0]) {
            const fieldName = 'file'
            const fileType = files[0].type
            const fileSize = files[0].size

            if(fileType && (fileType.indexOf('png') === -1 && fileType.indexOf('jpeg') === -1)) {
                setError(fieldName, {
                    type: 'format',
                    message: 'Selecciona formato png ó jpg',
                })
                return ;
            } else if(fileSize && (fileSize / 1024 > 500)) {
                setError(fieldName, {
                    type: 'size',
                    message: 'Selecciona tamaño máximo 500KB',
                })
                return ;
            }

            const image = URL.createObjectURL(files[0])
            setAvatarImg(image)
            clearErrors(fieldName)
        }
    }

    const onSecondNameChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { target: { value } } = event
        const fieldName = 'secondName'

        if(value) clearErrors('lastName')

        setValue(fieldName, value)
        setTimeout(() => setFocus(fieldName), 0)
    }

    const onRegionChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const { target: { value } } = event
        cities.getCities(Number(value))
        communes.setEmpty()
        setValue('cityId', '')
        setValue('communeId', '')
        if(value) clearErrors('regionId')
    }

    const onCityChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const { target: { value } } = event
        communes.getCommunes(Number(value))
        setValue('communeId', '')
        if(value) clearErrors('cityId')
    }

    const onPasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { target: { value } } = event
        const fieldName = 'password'

        setValue(fieldName, value, {
            shouldValidate: true,
            shouldDirty: true
        })
    }

    const onConfirmPasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { target: { value } } = event
        const fieldName = 'confirmPassword'

        setValue(fieldName, value, {
            shouldValidate: true,
            shouldDirty: true
        })
    }

    const onDateBirthChange = async (date: Date) => {
        const dateStr: string = String(utils.getDateFormat(date, 'YYYY-MM-DD'))

        if(dateStr) {
            const resp: any = await userService.getUserAgeValidate(dateStr)

            if(resp.data && resp.data?.is_minor) {
                modal.setMessage(resp.data?.msg)
                modal.open()
            }
        }
    }

  const onTermAndCond = () => {
    modalTermAndCond.open()
  }

    const onSubmit = async (fData: IAuthRegisterForm) => {
        const {
            file,
            documentNumber,
            firstName,
            lastName,
            secondName,
            dateBirth,
            nationalityId,
            forecastId,
            genderId,
            email,
            regionId,
            cityId,
            communeId,
            address,
            phone,
            password
        } = fData
        const formReg = new FormData()

        await auditService.updatePatienteRegister({
            status: "up_register_submit",
            document_type_id : docType,
            document_number : documentNumber
        })

        formReg.append('file', (file ? file[0] : ''))
        formReg.append('document_type_id', String(docType))
        formReg.append('document_number', (docType === EDocumentType.rut ? lRut.clean(documentNumber) : documentNumber))
        formReg.append('first_name', firstName)
        formReg.append('last_name', lastName)
        formReg.append('second_name', secondName)
        formReg.append('date_birth', `${utils.getDateFormat(dateBirth, 'YYYY-MM-DD')}`)
        formReg.append('nationality_id', nationalityId)
        formReg.append('forecast_id', forecastId)
        formReg.append('gender_id', genderId)
        formReg.append('email', email)
        formReg.append('region_id', regionId)
        formReg.append('city_id', cityId)
        formReg.append('commune_id', communeId)
        formReg.append('address', address)
        formReg.append('phone', phone)
        formReg.append('password', password)

        if(docType === EDocumentType.passport && passportFiles) {
            const { passport, photoPassport } = passportFiles

            formReg.append('file_passport', (passport ? passport[0] : ''))
            formReg.append('file_passport_patient', (photoPassport ? photoPassport[0] : ''))
        } else if(docType === EDocumentType.rut) {
            let lsFormData: any = formData.get()
            if(lsFormData) formReg.append('solem', lsFormData)
            formReg.append('number', (lsFormData.documentNumber2 ? lsFormData.documentNumber2 : ''))
        }

        setSubmited(true)
        postForm(formReg)
    }

    const [disableButtonAccept, setDisableButtonAccept] = React.useState(true);
    const [disableCheckedTerm, setDisableCheckedTerm] = React.useState(true);
    const [isCheckedTerm, setCheckedTerm] = React.useState(false);

    const handleScroll = (status: boolean) => {
/*         if(!status) {
            setDisableCheckedTerm(true)
            setDisableButtonAccept(true)
        }
        if(status) {
            setDisableCheckedTerm(false)
        }
        setDisableButtonAccept(true)
        if(isCheckedTerm && status) {
            setDisableButtonAccept(false)
        } */
    }

    const onChangeAcceptTermAndCondition = (event: any) => {
        const { target : {name, checked} } = event

        if (checked) {
            setDisableButtonAccept(false)
        }

        if (!checked) {
            setDisableButtonAccept(true)
        }
        setCheckedTerm(checked)
        clearErrors([name])
    }

    return (
        <>
            <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                <FormTitle>Datos personales</FormTitle>

                <div className="mt-40 lg:mt-50 lg:offset-1">
                    <div className="register-form-avatar">
                        <Avatar
                            src={avatarImg ? avatarImg : avatarDefaultImg}
                            size="160"
                            className="register-form-avatar_img"
                        />

                        <div className="register-form-avatar_icon">
                            <Icon name="photo" />
                            <input
                                {...register('file')}
                                type="file"
                                id="file"
                                name="file"
                                accept="image/x-png,image/jpeg"
                                onChange={onAvatarChange}
                            />
                        </div>
                    </div>
                    <Text component="label" size="12" className="mt-5">Imagen con formato .jpg, .png y máximo 500KB</Text>
                    {errors.file && <FormLabelError>{errors.file?.message}</FormLabelError>}
                </div>

                <div className="row mt-40">
                    <FormFieldset className="lg:order-1">
                        <FormLabel htmlFor="firstName" required>Nombres</FormLabel>
                        <Input
                            {...register('firstName', { required: 'Digita Nombre' })}
                            id="firstName"
                            name="firstName"
                            placeholder="Nombre"
                            tabIndex={1}
                            fullWidth
                            error={!!errors.firstName}
                            className="mt-5"
                        />
                        {errors.firstName && <FormLabelError>{errors.firstName?.message}</FormLabelError>}
                    </FormFieldset>

                    <FormFieldset className="lg:order-3 mt-30">
                        <FormLabel htmlFor="lastName" required>Primer apellido</FormLabel>
                        <Input
                            {...register('lastName', {
                                validate: {
                                    required: (value) => {
                                        if (!value && !getValues('secondName')) return 'Digita Primer apellido'
                                        return true
                                    }
                                }
                            })}
                            id="lastName"
                            name="lastName"
                            placeholder="Apellido"
                            tabIndex={2}
                            fullWidth
                            error={!!errors.lastName}
                            className="mt-5"
                        />
                        {errors.lastName && <FormLabelError>{errors.lastName?.message}</FormLabelError>}
                    </FormFieldset>

                    <FormFieldset className="lg:order-5 mt-30">
                        <FormLabel htmlFor="secondName">Segundo apellido</FormLabel>
                        <Input
                            {...register('secondName')}
                            id="secondName"
                            name="secondName"
                            placeholder="Apellido"
                            tabIndex={3}
                            fullWidth
                            className="mt-5"
                            onChange={onSecondNameChange}
                        />
                    </FormFieldset>

                    <FormFieldset className="lg:order-7 mt-30">
                        {docType === EDocumentType.rut &&
                            <>
                                <FormLabel htmlFor="documentNumber" required>{CONFIG.AUTH.LABEL.RUT}</FormLabel>
                                <Input
                                    {...register('documentNumber', {
                                        required: `Digita ${CONFIG.AUTH.LABEL.RUT}`,
                                        validate: value => lRut.validate(value) || `Digita ${CONFIG.AUTH.LABEL.RUT} válido`
                                    })}
                                    id="documentNumber"
                                    name="documentNumber"
                                    placeholder={CONFIG.AUTH.PLACEHOLDER.RUT}
                                    maxLength={CONFIG.FORM.PATTERN.RUT.MAXLENGHT}
                                    fullWidth
                                    tabIndex={4}
                                    readOnly
                                    error={!!errors.documentNumber}
                                    className="mt-5"
                                />
                                {errors?.documentNumber && <FormLabelError>{errors.documentNumber?.message}</FormLabelError>}
                            </>
                        }

                        {docType === EDocumentType.passport &&
                            <>
                                <Text component="label" htmlFor="documentNumber" size="14" weight="semibold">{CONFIG.AUTH.LABEL.PASSPORT} <span className="text-primary">*</span></Text>
                                <Input
                                    {...register('documentNumber', {
                                        required: `Digita ${CONFIG.AUTH.LABEL.PASSPORT}`,
                                        pattern: { value: CONFIG.FORM.PATTERN.PASSPORT.EXP, message: `Digita ${CONFIG.AUTH.LABEL.PASSPORT} válido` },
                                        validate: value => true
                                    })}
                                    id="documentNumber"
                                    name="documentNumber"
                                    placeholder={CONFIG.AUTH.PLACEHOLDER.PASSPORT}
                                    fullWidth
                                    tabIndex={4}
                                    readOnly
                                    error={!!errors.documentNumber}
                                    className="mt-5"
                                />
                                {errors.documentNumber && <FormLabelError>{errors.documentNumber?.message}</FormLabelError>}
                            </>
                        }
                    </FormFieldset>

                    <FormFieldset className="lg:order-2 mt-30 lg:mt-0">
                        <FormLabel htmlFor="dateBirth" required>Fecha de nacimiento</FormLabel>
                        <div className="mt-5">
                            <Controller
                                control={control}
                                name='dateBirth'
                                render={({ field }) => (
                                    <DatePicker
                                        {...register('dateBirth', { required: 'Selecciona Fecha de nacimiento' })}
                                        selected={field.value}
                                        openToDate={new Date('2000/01/01')}
                                        showYearDropdown
                                        showMonthDropdown
                                        customInput={
                                            React.createElement(
                                                DatePickerInput,
                                                {
                                                    error: !!errors.dateBirth,
                                                    tabsIndex: 5
                                                }
                                            )
                                        }
                                        onChange={(date) => {
                                            field.onChange(date)
                                            onDateBirthChange(date)
                                        }}
                                    />
                                )}
                            />
                        </div>
                        {(errors.dateBirth) && <FormLabelError>Selecciona Fecha de nacimiento</FormLabelError>}
                    </FormFieldset>

                    <FormFieldset className="lg:order-4 mt-30">
                        <FormLabel htmlFor="nationalityId" required>Nacionalidad</FormLabel>
                        <Select
                            {...register('nationalityId', { required: 'Selecciona Nacionalidad' })}
                            id="nationalityId"
                            name="nationalityId"
                            defaultValue=""
                            tabIndex={6}
                            fullWidth
                            required
                            loading={nationalities.data === null}
                            error={!!errors.nationalityId}
                            className="mt-5"
                        >
                            <option value="" disabled>Selecciona</option>
                            {nationalities.data && nationalities.data.length > 0 &&
                                nationalities.data.map((it: INationality) => <option key={it.id} value={it.id}>{it.name}</option>)
                            }
                        </Select>
                        {errors.nationalityId && <FormLabelError>{errors.nationalityId?.message}</FormLabelError>}
                    </FormFieldset>

                    <FormFieldset className="lg:order-6 mt-30">
                        <FormLabel htmlFor="forecastId" required>Previsión</FormLabel>
                        <Select
                            {...register('forecastId', { required: 'Selecciona Previsión' })}
                            id="forecastId"
                            name="forecastId"
                            defaultValue=""
                            tabIndex={7}
                            fullWidth
                            required
                            loading={forecasts.data === null}
                            error={!!errors.forecastId}
                            className="mt-5"
                        >
                            <option value="" disabled>Selecciona</option>
                            {forecasts && forecasts.data && forecasts.data.length > 0 && forecasts.data.map((it: IForecast) => <option key={it.id} value={it.id} hidden={it.status == 0 ? true : false}>{it.nombre}</option>)}
                        </Select>
                        {errors.forecastId && <FormLabelError>{errors.forecastId?.message}</FormLabelError>}
                    </FormFieldset>

                    <FormFieldset className="lg:order-8 mt-30">
                        <FormLabel required>Género</FormLabel>
                        <div className="position-relative mt-5">
                            {genders.data ?
                                genders.data.map((it: IGender, i: number) => (
                                    <div key={it.id} className={`d-inline-block${i > 0 ? ' ml-20' : ''}`}>
                                        <Radio
                                            {...register('genderId', { required: 'Selecciona Género' })}
                                            id={`sex${it.name}`}
                                            name="sex"
                                            value={it.id}
                                            tabIndex={i + 8}
                                            error={!!errors.genderId}
                                            onChange={() => fieldErrorRemove('genderId', String(it.id))}
                                        />
                                        <Text component="label" htmlFor={`sex${it.name}`} size="14" weight="semibold">{it.name}</Text>
                                    </div>
                                ))
                                :
                                <FormFieldLoading overlay />
                            }
                        </div>
                        {errors.genderId && <FormLabelError>{errors.genderId?.message}</FormLabelError>}
                    </FormFieldset>
                </div>

                <FormTitle className="mt-60">Datos de contacto</FormTitle>

                <div className="row mt-40">
                    <FormFieldset className="lg:order-1">
                        <FormLabel htmlFor="email" required>E-mail</FormLabel>
                        <Input
                            {...register('email', { required: 'Digita E-mail', pattern: { value: CONFIG.FORM.PATTERN.EMAIL, message: 'Digita E-mail válido' } })}
                            id="email"
                            name="email"
                            placeholder="E-mail"
                            tabIndex={11}
                            fullWidth
                            error={!!errors.email}
                            className="mt-5"
                        />
                        {errors.email && <FormLabelError>{errors.email?.message}</FormLabelError>}
                    </FormFieldset>

                    <FormFieldset className="lg:order-3 mt-30">
                        <FormLabel htmlFor="address" required>Dirección</FormLabel>
                        <Input
                            {...register('address', { required: 'Digita Dirección' })}
                            id="address"
                            name="address"
                            placeholder="Calle"
                            tabIndex={12}
                            fullWidth
                            error={!!errors.address}
                            className="mt-5"
                        />
                        {errors.address && <FormLabelError>{errors.address?.message}</FormLabelError>}
                    </FormFieldset>

                    <FormFieldset className="lg:order-5 mt-30">
                        <FormLabel htmlFor="phone" required>Teléfono</FormLabel>
                        <Input
                            {...register('phone', { required: 'Digita Teléfono', pattern: { value: CONFIG.FORM.PATTERN.PHONE.EXP, message: 'Digita Teléfono válido' }})}
                            type="tel"
                            id="phone"
                            name="phone"
                            placeholder="9XXXXXXXX"
                            maxLength={CONFIG.FORM.PATTERN.PHONE.MAXLENGHT}
                            tabIndex={13}
                            fullWidth
                            error={!!errors.phone}
                            className="mt-5"
                        />
                        {errors.phone && <FormLabelError>{errors.phone?.message}</FormLabelError>}
                    </FormFieldset>

                    <FormFieldset className="lg:order-2 mt-30 lg:mt-0">
                        <FormLabel htmlFor="regionId" required>Región</FormLabel>
                        <Select
                            {...register('regionId', { required: 'Selecciona Región' })}
                            id="regionId"
                            name="regionId"
                            defaultValue=""
                            tabIndex={14}
                            fullWidth
                            required
                            loading={regions.data === null}
                            error={!!errors.regionId}
                            className="mt-5"
                            onChange={onRegionChange}
                        >
                            <option value="" disabled>Selecciona</option>
                            {regions.data && regions.data.length > 0 && regions.data.map((it: IRegion) => <option key={it.id} value={it.id}>{it.name}</option>)}
                        </Select>
                        {errors.regionId && <FormLabelError>{errors.regionId?.message}</FormLabelError>}
                    </FormFieldset>

                    <FormFieldset className="lg:order-4 mt-30">
                        <FormLabel htmlFor="cityId" required>Provincia</FormLabel>
                        <Select
                            {...register('cityId', { required: 'Selecciona Provincia' })}
                            id="cityId"
                            name="cityId"
                            defaultValue=""
                            tabIndex={15}
                            fullWidth
                            required
                            error={!!errors.cityId}
                            disabled={!cities.data?.length}
                            loading={cities.data === null}
                            className="mt-5"
                            onChange={onCityChange}
                        >
                            <option value="" disabled>Selecciona</option>
                            {cities.data && cities.data.map((it: ICity) => <option key={it.id} value={it.id}>{it.name}</option>)}
                        </Select>
                        {errors.cityId && <FormLabelError>{errors.cityId?.message}</FormLabelError>}
                    </FormFieldset>

                    <FormFieldset className="lg:order-5 mt-30">
                        <FormLabel htmlFor="communeId" required>Comuna</FormLabel>
                        <Select
                            {...register('communeId', { required: 'Selecciona Comuna' })}
                            id="communeId"
                            name="communeId"
                            defaultValue=""
                            tabIndex={16}
                            fullWidth
                            required
                            error={!!errors.communeId}
                            disabled={!communes.data?.length}
                            loading={communes.data === null}
                            className="mt-5"
                        >
                            <option value="" disabled>Selecciona</option>
                            {communes.data && communes.data.map((it: ICommune) => <option key={it.id} value={it.id}>{it.name}</option>)}
                        </Select>
                        {errors.communeId && <FormLabelError>{errors.communeId?.message}</FormLabelError>}
                    </FormFieldset>
                </div>

                <FormTitle className="mt-60">Datos de la cuenta</FormTitle>

                <div className="row mt-40">
                    <FormFieldset>
                        <FormLabel htmlFor="password" required>Contraseña</FormLabel>
                        <Input
                            {...register('password',
                                {
                                    required: 'Digita Contraseña',
                                    pattern: {
                                        value: CONFIG.FORM.PATTERN.PASSWORD.EXP,
                                        message: 'Digita Contraseña válida'
                                    },
                                    minLength: {
                                        value: CONFIG.FORM.PATTERN.PASSWORD.MINLENGHT,
                                        message: `Digita mínimo ${CONFIG.FORM.PATTERN.PASSWORD.MINLENGHT} caracteres`
                                    }
                                }
                            )}
                            type={showPassword ? "text" : "password"}
                            id="password"
                            name="password"
                            placeholder="Contraseña"
                            tabIndex={17}
                            fullWidth
                            autoComplete="new-password"
                            error={!!errors.password}
                            className="mt-5"
                            onChange={onPasswordChange}
                        />
                        {errors.password && 
                            <>
                                <FormLabelError>{errors.password?.message}</FormLabelError>
                                <Text component="label" size="11" className="lg:fz-12">*Requisitos: 8 caracteres, 1 máyúscula, 1 minúscula y 1 número.</Text>
                            </>
                        }
                        <ShowPassword 
                            showPassword={showPassword} 
                            setShowPassword={setShowPassword} 
                            inputId="password-toggle"
                        />
                    </FormFieldset>

                    <FormFieldset className="mt-30 lg:mt-0">
                        <FormLabel htmlFor="confirmPassword" required>Confirmación de contraseña</FormLabel>
                        <Input
                            {...register('confirmPassword',
                                {
                                    required: 'Digita Confirmación de contraseña',
                                    pattern: { 
                                        value: CONFIG.FORM.PATTERN.PASSWORD.EXP,
                                        message: 'Digita Contraseña válida'
                                    },
                                    minLength: {
                                        value: CONFIG.FORM.PATTERN.PASSWORD.MINLENGHT,
                                        message: `Digita mínimo ${CONFIG.FORM.PATTERN.PASSWORD.MINLENGHT} caracteres`
                                    },
                                    validate: value => value === password.current || 'Las contraseñas no coinciden'
                                }
                            )}
                            type={showConfirmPassword ? "text" : "password"}
                            id="confirmPassword"
                            name="confirmPassword"
                            placeholder="Confirmación de contraseña"
                            tabIndex={18}
                            fullWidth
                            error={!!errors.confirmPassword}
                            className="mt-5"
                            onChange={onConfirmPasswordChange}
                        />
                        {errors.confirmPassword && <FormLabelError>{errors.confirmPassword?.message}</FormLabelError>}
                        <ShowPassword 
                            showPassword={showConfirmPassword} 
                            setShowPassword={setShowConfirmPassword}
                            inputId="confirm-password-toggle"
                        />
                    </FormFieldset>
                </div>

                <FormTitle className="mt-60">Términos y condiciones</FormTitle>

                <div className="row mt-40">
                    <fieldset className="col-12 lg:text-center">
                        <div>
                        <Checkbox
                            {...register('term', { required: 'Acepta términos y condiciones' })}
                            id="term"
                            name="term"
                            value="true"
                            tabIndex={19}
                            error={!!errors.term}
                            className="text-gray-700"
                            // disabled={disableCheckedTerm}
                            onChange={onChangeAcceptTermAndCondition}
                        />
                        <FormLabel htmlFor="term" required>
                            <a href="https://www.indisa.cl/files/2021/08/PORTAL_Terminos-y-condiciones.pdf" target="_blank" rel="noreferrer" className="text-du">Aceptar términos y condiciones</a>
                        </FormLabel>


                        </div>
                        {errors.term && <FormLabelError>{errors.term?.message}</FormLabelError>}
                    </fieldset>
                </div>


                <div className="register-form-btn-wrapper mt-50 lg:mt-60">
                    <Button
                        type="submit"
                        tabIndex={20}
                        fullWidth
                        disabled={submited}
                        loading={submited}
                    >REGISTRARME</Button>
                </div>
        </form>

        <Modal buttonCloseHide={false} show={modalTermAndCond.show} maxWidth="490px" onClose={() => modalTermAndCond.close()}>
          <div className='p-25'>
            <TermAndCondition className='overflow-y hmax-242 mt-30 box_shadow' onScrollParam={handleScroll}></TermAndCondition>
            <div className='d-block text-center mt-10'>
                <div className='fz-12 text-left mb-20 wmax-383'> * Revisa términos y condiciones completamente para poder habilitar botón de aceptación.</div>
{/*               <Checkbox
                {...register('term', { required: 'Acepta términos y condiciones' })}
                id="term"
                name="term"
                value="true"
                tabIndex={19}
                error={!!errors.term}
                className="text-gray-700"
                disabled={disableCheckedTerm}
                onChange={onChangeAcceptTermAndCondition}
              />
              <FormLabel htmlFor="term" required>
                <span>Aceptar términos y condiciones</span>
              </FormLabel> */}
            </div>
            <div className='d-block text-center'>
              <Button disabled={disableButtonAccept} className="mt-30" onClick={() => modalTermAndCond.close()}>ACEPTAR</Button>
            </div>
          </div>
        </Modal>

          
            <Modal show={modal.show} maxWidth="490px" onClose={() => modal.close()}>
                <FormMessageInfo
                    message={modal.message}
                    className="py-80 px-20"
                    buttonText="CONTINUAR"
                    onClick={() => modal.close()}
                />
            </Modal>
        </>
    )
}

export { RegisterForm }
